module.exports = __webpack_public_path__ + "static/media/Pernas.c1c7fdcc.png";